import { render, staticRenderFns } from "./TestimonialListing.vue?vue&type=template&id=c6bfbbd8&"
import script from "./TestimonialListing.vue?vue&type=script&lang=js&"
export * from "./TestimonialListing.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports